import { makeCancellableAPIRequest } from "restAPI";
import { AIPersonaDTO } from "types/api/AIPersonaDTO";

export type AIPersonaPalyloadType = Pick<
  AIPersonaDTO,
  "name" | "prompt" | "isActive"
>;

const AIPersonaAPI = {
  createPersona(data: AIPersonaPalyloadType) {
    const { promise, cancel } = makeCancellableAPIRequest<{
      data: AIPersonaDTO;
    }>("POST", "/api/ai/personas", {
      data,
    });
    const newPromise: Promise<AIPersonaDTO> = promise.then((res) => res.data);
    return { promise: newPromise, cancel };
  },
  updatePersona(
    id: AIPersonaDTO["id"],
    data: AIPersonaPalyloadType | Pick<AIPersonaDTO, "isActive">,
  ) {
    const { promise, cancel } = makeCancellableAPIRequest<{
      data: AIPersonaDTO;
    }>("PUT", `/api/ai/personas/${id}`, {
      data,
    });
    const newPromise: Promise<AIPersonaDTO> = promise.then((res) => res.data);
    return { promise: newPromise, cancel };
  },
  deletePersona(id: AIPersonaDTO["id"]) {
    return makeCancellableAPIRequest("DELETE", `/api/ai/personas/${id}`);
  },
  getPersonas() {
    const { promise, cancel } = makeCancellableAPIRequest<{
      data: AIPersonaDTO[];
    }>("GET", "/api/ai/personas");

    const newPromise: Promise<AIPersonaDTO[]> = promise.then((res) => res.data);
    return { promise: newPromise, cancel };
  },
};

export default AIPersonaAPI;
